import React from 'react';
import '../../resources/css/loading_compass/LoadingCompass.css';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../resources/strings/StringKeys';

const LoadingCompass = ({ loadingText, isReadyToEnter, onEnterClick }) => {
  const { t } = useTranslation();
  if (loadingText === undefined) loadingText = t(StringKeys.LOADING);

  return (
    <div className={`loading-compass loaded`}>
      <div className="loading-logo"></div>

      {/* Show loading animation and text only when NOT ready */}
      {!isReadyToEnter && (
        <>
          <div className="loading-icon"></div>
          <div className="loading-text">{loadingText}</div>
        </>
      )}

      {/* Show "Click to Enter" button when ready */}
      {isReadyToEnter && (
        <button className="enter-button" onClick={onEnterClick}>
          {t(StringKeys.CLICK_TO_ENTER)}
        </button>
      )}

      <div className="overlay"></div>
    </div>
  );
};

export default LoadingCompass;
